module.exports = __webpack_public_path__ + "static/media/logo.031976c4.png";